const _excluded = ["value", "onChange", "testid", "data-testid", "isBillInStages"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import { MenuItem, TextField } from 'seagull';
import { positiveQuantityInputProps } from "../constants";
import { jsx as _jsx } from "react/jsx-runtime";
export default function DiscountTextField(props) {
  const {
      value,
      onChange: _onChange,
      testid,
      ['data-testid']: dtestid,
      isBillInStages
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const isPercentDiscount = value.type === 'percent';
  const tid = dtestid || testid;
  return /*#__PURE__*/_jsx(TextField, _objectSpread({
    disableSuffixPadding: true,
    isPercentage: isPercentDiscount,
    isMoney: !isPercentDiscount,
    inputProps: positiveQuantityInputProps,
    value: value.amount,
    "data-testid": tid && tid + '-amount',
    onChange: e => {
      const amount = e.target.value;
      _onChange({
        amount,
        type: value.type
      });
    },
    suffix: /*#__PURE__*/_jsx(TextField, {
      select: true,
      preventOutline: true,
      width: 60,
      minWidth: 60,
      size: props.size,
      disabled: props.disabled,
      SelectProps: {
        autoWidth: true
      },
      value: value.type,
      "data-testid": tid && tid + '-type',
      onChange: e => {
        const type = e.target.value;
        _onChange({
          type,
          amount: value.amount
        });
      },
      onBlur: rest.onBlur,
      children: [{
        value: 'percent',
        text: '%'
      }, {
        value: 'value',
        text: '$'
      }].map(_ref => {
        let {
          value,
          text
        } = _ref;
        const isBillInStagesAndNonPercentage = isBillInStages && value !== 'percent';
        return /*#__PURE__*/_jsx(MenuItem, {
          disabled: isBillInStagesAndNonPercentage,
          value: value,
          "data-testid": tid && "".concat(tid, "-option-").concat(value),
          tooltipProps: {
            title: isBillInStagesAndNonPercentage ? 'Must be a percentage when billing in stages' : ''
          },
          children: text
        }, value);
      })
    })
  }, rest));
}